import React from 'react';
import DrawBase from '../components/base/draw-base';

const ChampionshipRulesDraw = () => {
  return <DrawBase sportType="general" />;
};

export default ChampionshipRulesDraw;
